import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _AvatarGetter = Getter.of();
export const _AvatarResponseGetter = Getter.of();
export const _AvatarsGetter = Getter.of();
export const _AvatarsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _AvatarsResponse2Avatars = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _AvatarsResponse2Meta = Fold.compose(_AvatarsResponseGetter, Res._Response(), Lens.prop("meta"));
export const _AvatarResponse2Avatar = _Response2ResponseData();
export const _AvatarResponse2Meta = Fold.compose(_AvatarResponseGetter, Res._Response(), Lens.prop("meta"));
export const _Avatar2Data = Fold.compose(_AvatarGetter, Res._Response());
export const _Avatars2Data = Fold.compose(_AvatarsGetter, Res._Response());
export const _Avatar2Attributes = Fold.compose(_Avatar2Data, Lens.prop("attributes"));
export const _Avatars2Attributes = Fold.compose(_Avatars2Data, Fold._each(), Lens.prop("attributes"));
export const _AvatarsAttributes2DisplayName = Fold.compose(_Avatars2Attributes, Lens.prop("displayName"));
export const _AvatarsAttributes2IsDefault = Fold.compose(_Avatars2Attributes, Lens.prop("isDefault"));
export const _AvatarsAttributes2ImageUrl = Fold.compose(_Avatars2Attributes, Lens.prop("imageUrl"));
export const _AvatarsAttributes2Category = Fold.compose(_Avatars2Attributes, Lens.prop("category"));

